import { useTranslation } from 'react-i18next';
import InputText from '../Forms/Element/InputText';
import { FormGroup, FormLabel } from 'react-bootstrap';

const PhoneNumberInput = (props) => {
    const { formik, error, name } = props;
    const { t } = useTranslation();

    return (
        <InputText
            name={name}
            placeholder={t('phone_placeholder')}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[name]} // Acessa dinamicamente pelo nome
            error={error}
            maxLength="20" // Limite razoável para telefones
        />
    );
}

export default PhoneNumberInput;